import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Upload: { input: any; output: any; }
};

export type AccessLink = {
  __typename?: 'AccessLink';
  expiresAt: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type AdminLoginHistoryEntry = {
  __typename?: 'AdminLoginHistoryEntry';
  eventType: Scalars['String']['output'];
  failureReason: Maybe<Scalars['String']['output']>;
  generatedBy: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipAddress: Maybe<Scalars['String']['output']>;
  messageId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  timestamp: Scalars['String']['output'];
  tokenExpiry: Maybe<Scalars['String']['output']>;
  userAgent: Maybe<Scalars['String']['output']>;
};

export type AdminMutation = {
  __typename?: 'AdminMutation';
  createClient: Client;
  createSupplier: Supplier;
  createUser: User;
  deleteClient: Scalars['Boolean']['output'];
  deleteFile: Scalars['Boolean']['output'];
  deleteSupplier: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  generateAccessLink: AccessLink;
  generateMagicLink: AccessLink;
  getClientFilesZipUrl: ZipDownloadResponse;
  noop: Maybe<Scalars['Boolean']['output']>;
  sendMagicLink: MagicLinkSendResult;
  updateClient: Maybe<Client>;
  updateSupplier: Maybe<Supplier>;
  updateUser: Maybe<User>;
};


export type AdminMutationCreateClientArgs = {
  client_name: Scalars['String']['input'];
  folder: Scalars['String']['input'];
};


export type AdminMutationCreateSupplierArgs = {
  clientId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  subfolder: Scalars['String']['input'];
};


export type AdminMutationCreateUserArgs = {
  clientId: InputMaybe<Scalars['ID']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  role: Role;
  supplierId: InputMaybe<Scalars['ID']['input']>;
  supplierName: InputMaybe<Scalars['String']['input']>;
  supplierSubfolder: InputMaybe<Scalars['String']['input']>;
};


export type AdminMutationDeleteClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type AdminMutationDeleteFileArgs = {
  id: Scalars['ID']['input'];
};


export type AdminMutationDeleteSupplierArgs = {
  id: Scalars['ID']['input'];
};


export type AdminMutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type AdminMutationGenerateAccessLinkArgs = {
  clientId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type AdminMutationGenerateMagicLinkArgs = {
  userId: Scalars['ID']['input'];
};


export type AdminMutationGetClientFilesZipUrlArgs = {
  clientId: Scalars['ID']['input'];
};


export type AdminMutationSendMagicLinkArgs = {
  userId: Scalars['ID']['input'];
};


export type AdminMutationUpdateClientArgs = {
  clientId: Scalars['ID']['input'];
  client_name: InputMaybe<Scalars['String']['input']>;
  folder: InputMaybe<Scalars['String']['input']>;
  upload_complete: InputMaybe<Scalars['Boolean']['input']>;
};


export type AdminMutationUpdateSupplierArgs = {
  id: Scalars['ID']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  subfolder: InputMaybe<Scalars['String']['input']>;
};


export type AdminMutationUpdateUserArgs = {
  clientId: InputMaybe<Scalars['ID']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  supplierId: InputMaybe<Scalars['ID']['input']>;
};

export type AdminQuery = {
  __typename?: 'AdminQuery';
  client: Maybe<Client>;
  clients: Array<Client>;
  files: Array<FileData>;
  filesByQuarantineStatus: Array<FileData>;
  hello: Scalars['String']['output'];
  quarantinedFiles: Array<FileData>;
  supplier: Maybe<Supplier>;
  suppliers: Array<Supplier>;
  user: Maybe<User>;
  userLoginHistory: UserLoginHistoryResponse;
  users: Array<User>;
};


export type AdminQueryClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type AdminQueryFilesByQuarantineStatusArgs = {
  status: QuarantineStatus;
};


export type AdminQuerySupplierArgs = {
  id: Scalars['ID']['input'];
};


export type AdminQueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type AdminQueryUserLoginHistoryArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};

export type AuthResult = {
  __typename?: 'AuthResult';
  sessionToken: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user: User;
};

export type Client = {
  __typename?: 'Client';
  clientId: Scalars['ID']['output'];
  client_name: Scalars['String']['output'];
  files: Maybe<Array<FileData>>;
  folder: Scalars['String']['output'];
  suppliers: Maybe<Array<Supplier>>;
  upload_complete: Scalars['Boolean']['output'];
  users: Maybe<Array<User>>;
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type FileData = {
  __typename?: 'FileData';
  client: Maybe<Client>;
  clientId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileUrl: Maybe<Scalars['String']['output']>;
  folderPath: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  quarantineReason: Maybe<Scalars['String']['output']>;
  quarantineStatus: QuarantineStatus;
  quarantineTimestamp: Maybe<Scalars['String']['output']>;
  reviewedByCurrentUser: Maybe<Scalars['Boolean']['output']>;
  scanCompletedAt: Maybe<Scalars['String']['output']>;
  scanEngine: Maybe<Scalars['String']['output']>;
  scanEngineVersion: Maybe<Scalars['String']['output']>;
  scanStartedAt: Maybe<Scalars['String']['output']>;
  subfolderPath: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
  userId: Maybe<Scalars['ID']['output']>;
};

export type FileReview = {
  __typename?: 'FileReview';
  file: FileData;
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  reviewedAt: Scalars['String']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type LoginHistory = {
  __typename?: 'LoginHistory';
  id: Scalars['ID']['output'];
  ipAddress: Maybe<Scalars['String']['output']>;
  loginAt: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MagicLinkRequestResult = {
  __typename?: 'MagicLinkRequestResult';
  message: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
};

export type MagicLinkSendResult = {
  __typename?: 'MagicLinkSendResult';
  expiresAt: Scalars['String']['output'];
  magicLinkUrl: Maybe<Scalars['String']['output']>;
  messageId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  admin: AdminMutation;
  authExchangeMagicLinkToken: AuthResult;
  createFile: FileData;
  deleteFile: Scalars['Boolean']['output'];
  getClientFilesZipUrl: ZipDownloadResponse;
  getS3UploadUrl: S3UploadUrl;
  markClientUploadsComplete: Client;
  requestMagicLink: MagicLinkRequestResult;
  saveFileMetadata: FileData;
  toggleFileReview: FileData;
  updateFile: Maybe<FileData>;
  uploadFile: FileData;
};


export type MutationAuthExchangeMagicLinkTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationCreateFileArgs = {
  clientId: Scalars['ID']['input'];
  extension: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationDeleteFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGetClientFilesZipUrlArgs = {
  clientId: Scalars['ID']['input'];
};


export type MutationGetS3UploadUrlArgs = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationMarkClientUploadsCompleteArgs = {
  clientId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
  markAsComplete: Scalars['Boolean']['input'];
};


export type MutationRequestMagicLinkArgs = {
  email: Scalars['String']['input'];
};


export type MutationSaveFileMetadataArgs = {
  clientId: Scalars['ID']['input'];
  extension: Scalars['String']['input'];
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationToggleFileReviewArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationUpdateFileArgs = {
  extension: InputMaybe<Scalars['String']['input']>;
  fileName: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload']['input'];
};

export enum QuarantineStatus {
  Clean = 'CLEAN',
  Quarantined = 'QUARANTINED',
  ScanFailed = 'SCAN_FAILED'
}

export type Query = {
  __typename?: 'Query';
  admin: AdminQuery;
  allClients: Array<Client>;
  allFiles: Array<FileData>;
  checkFileExistsInS3: S3FileCheckResult;
  currentUser: Maybe<User>;
  file: Maybe<FileData>;
  filesByClient: Array<FileData>;
  myLoginHistory: Array<LoginHistory>;
};


export type QueryCheckFileExistsInS3Args = {
  key: Scalars['String']['input'];
};


export type QueryFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFilesByClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryMyLoginHistoryArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
};

export enum Role {
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  PortwayEmployee = 'PORTWAY_EMPLOYEE',
  Supplier = 'SUPPLIER'
}

export type S3FileCheckResult = {
  __typename?: 'S3FileCheckResult';
  contentLength: Maybe<Scalars['Int']['output']>;
  contentType: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
  exists: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type S3UploadUrl = {
  __typename?: 'S3UploadUrl';
  expectedContentType: Scalars['String']['output'];
  key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type Supplier = {
  __typename?: 'Supplier';
  client: Client;
  clientId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subfolder: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  client: Maybe<Client>;
  clientId: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  error: Maybe<Error>;
  files: Maybe<Array<FileData>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reviewedFiles: Maybe<Array<FileReview>>;
  role: Role;
  supplier: Maybe<Supplier>;
  supplierId: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type UserInfo = {
  __typename?: 'UserInfo';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type UserLoginHistoryResponse = {
  __typename?: 'UserLoginHistoryResponse';
  entries: Array<AdminLoginHistoryEntry>;
  user: UserInfo;
};

export type ZipDownloadResponse = {
  __typename?: 'ZipDownloadResponse';
  downloadUrl: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
  estimatedSize: Maybe<Scalars['Int']['output']>;
  fileCount: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
};

export type ClientDetailsFragment = { __typename?: 'Client', clientId: string, client_name: string, folder: string, upload_complete: boolean };

export type ClientWithFilesFragment = { __typename?: 'Client', clientId: string, client_name: string, folder: string, upload_complete: boolean, files: Array<{ __typename?: 'FileData', id: string, fileName: string, extension: string, createdAt: string, fileUrl: string | null, quarantineStatus: QuarantineStatus, quarantineReason: string | null, quarantineTimestamp: string | null, scanEngine: string | null, scanEngineVersion: string | null, scanStartedAt: string | null, scanCompletedAt: string | null }> | null };

export type AllClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllClientsQuery = { __typename?: 'Query', allClients: Array<{ __typename?: 'Client', clientId: string, client_name: string, folder: string, upload_complete: boolean }> };

export type AdminClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminClientsQuery = { __typename?: 'Query', admin: { __typename?: 'AdminQuery', clients: Array<{ __typename?: 'Client', clientId: string, client_name: string, folder: string, upload_complete: boolean, files: Array<{ __typename?: 'FileData', id: string, fileName: string, extension: string, createdAt: string, fileUrl: string | null, quarantineStatus: QuarantineStatus, quarantineReason: string | null, quarantineTimestamp: string | null, scanEngine: string | null, scanEngineVersion: string | null, scanStartedAt: string | null, scanCompletedAt: string | null }> | null }> } };

export type AdminClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type AdminClientQuery = { __typename?: 'Query', admin: { __typename?: 'AdminQuery', client: { __typename?: 'Client', clientId: string, client_name: string, folder: string, upload_complete: boolean, files: Array<{ __typename?: 'FileData', id: string, fileName: string, extension: string, createdAt: string, fileUrl: string | null, quarantineStatus: QuarantineStatus, quarantineReason: string | null, quarantineTimestamp: string | null, scanEngine: string | null, scanEngineVersion: string | null, scanStartedAt: string | null, scanCompletedAt: string | null }> | null } | null } };

export type AdminCreateClientMutationVariables = Exact<{
  client_name: Scalars['String']['input'];
  folder: Scalars['String']['input'];
}>;


export type AdminCreateClientMutation = { __typename?: 'Mutation', admin: { __typename?: 'AdminMutation', createClient: { __typename?: 'Client', clientId: string, client_name: string, folder: string, upload_complete: boolean } } };

export type AdminUpdateClientMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  client_name: InputMaybe<Scalars['String']['input']>;
  folder: InputMaybe<Scalars['String']['input']>;
  upload_complete: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminUpdateClientMutation = { __typename?: 'Mutation', admin: { __typename?: 'AdminMutation', updateClient: { __typename?: 'Client', clientId: string, client_name: string, folder: string, upload_complete: boolean } | null } };

export type AdminDeleteClientMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type AdminDeleteClientMutation = { __typename?: 'Mutation', admin: { __typename?: 'AdminMutation', deleteClient: boolean } };

export type FileDetailsFragment = { __typename?: 'FileData', id: string, fileName: string, extension: string, createdAt: string, reviewedByCurrentUser: boolean | null, quarantineStatus: QuarantineStatus, quarantineReason: string | null, quarantineTimestamp: string | null, scanEngine: string | null, scanEngineVersion: string | null, scanStartedAt: string | null, scanCompletedAt: string | null };

export type AllFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllFilesQuery = { __typename?: 'Query', allFiles: Array<{ __typename?: 'FileData', id: string, fileName: string, extension: string, createdAt: string, reviewedByCurrentUser: boolean | null, quarantineStatus: QuarantineStatus, quarantineReason: string | null, quarantineTimestamp: string | null, scanEngine: string | null, scanEngineVersion: string | null, scanStartedAt: string | null, scanCompletedAt: string | null }> };

export type GetFileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFileQuery = { __typename?: 'Query', file: { __typename?: 'FileData', id: string, fileName: string, extension: string, createdAt: string, reviewedByCurrentUser: boolean | null, quarantineStatus: QuarantineStatus, quarantineReason: string | null, quarantineTimestamp: string | null, scanEngine: string | null, scanEngineVersion: string | null, scanStartedAt: string | null, scanCompletedAt: string | null } | null };

export type CreateFileMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  extension: Scalars['String']['input'];
  clientId: Scalars['ID']['input'];
}>;


export type CreateFileMutation = { __typename?: 'Mutation', createFile: { __typename?: 'FileData', id: string, fileName: string, extension: string, createdAt: string, reviewedByCurrentUser: boolean | null, quarantineStatus: QuarantineStatus, quarantineReason: string | null, quarantineTimestamp: string | null, scanEngine: string | null, scanEngineVersion: string | null, scanStartedAt: string | null, scanCompletedAt: string | null } };

export type UpdateFileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fileName: InputMaybe<Scalars['String']['input']>;
  extension: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateFileMutation = { __typename?: 'Mutation', updateFile: { __typename?: 'FileData', id: string, fileName: string, extension: string, createdAt: string, reviewedByCurrentUser: boolean | null, quarantineStatus: QuarantineStatus, quarantineReason: string | null, quarantineTimestamp: string | null, scanEngine: string | null, scanEngineVersion: string | null, scanStartedAt: string | null, scanCompletedAt: string | null } | null };

export type DeleteFileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFile: boolean };

export type ToggleFileReviewMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type ToggleFileReviewMutation = { __typename?: 'Mutation', toggleFileReview: { __typename?: 'FileData', id: string, fileName: string, extension: string, createdAt: string, reviewedByCurrentUser: boolean | null, clientId: string } };

export type QuarantineFileDetailsFragment = { __typename?: 'FileData', id: string, fileName: string, extension: string, createdAt: string, fileUrl: string | null, folderPath: string | null, subfolderPath: string | null, clientId: string, quarantineStatus: QuarantineStatus, quarantineReason: string | null, quarantineTimestamp: string | null, scanEngine: string | null, scanEngineVersion: string | null, scanStartedAt: string | null, scanCompletedAt: string | null, client: { __typename?: 'Client', clientId: string, client_name: string, folder: string } | null, user: { __typename?: 'User', id: string, name: string, role: Role } | null };

export type AdminQuarantinedFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminQuarantinedFilesQuery = { __typename?: 'Query', admin: { __typename?: 'AdminQuery', quarantinedFiles: Array<{ __typename?: 'FileData', id: string, fileName: string, extension: string, createdAt: string, fileUrl: string | null, folderPath: string | null, subfolderPath: string | null, clientId: string, quarantineStatus: QuarantineStatus, quarantineReason: string | null, quarantineTimestamp: string | null, scanEngine: string | null, scanEngineVersion: string | null, scanStartedAt: string | null, scanCompletedAt: string | null, client: { __typename?: 'Client', clientId: string, client_name: string, folder: string } | null, user: { __typename?: 'User', id: string, name: string, role: Role } | null }> } };

export type AdminFilesByQuarantineStatusQueryVariables = Exact<{
  status: QuarantineStatus;
}>;


export type AdminFilesByQuarantineStatusQuery = { __typename?: 'Query', admin: { __typename?: 'AdminQuery', filesByQuarantineStatus: Array<{ __typename?: 'FileData', id: string, fileName: string, extension: string, createdAt: string, fileUrl: string | null, folderPath: string | null, subfolderPath: string | null, clientId: string, quarantineStatus: QuarantineStatus, quarantineReason: string | null, quarantineTimestamp: string | null, scanEngine: string | null, scanEngineVersion: string | null, scanStartedAt: string | null, scanCompletedAt: string | null, client: { __typename?: 'Client', clientId: string, client_name: string, folder: string } | null, user: { __typename?: 'User', id: string, name: string, role: Role } | null }> } };

export type GetUserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserDataQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, name: string, email: string | null, role: Role, clientId: string | null, supplierId: string | null, client: { __typename?: 'Client', clientId: string, client_name: string, folder: string } | null, supplier: { __typename?: 'Supplier', id: string, name: string, subfolder: string, clientId: string, client: { __typename?: 'Client', clientId: string, client_name: string, folder: string } } | null } | null };

export const ClientDetailsFragmentDoc = gql`
    fragment ClientDetails on Client {
  clientId
  client_name
  folder
  upload_complete
}
    `;
export const ClientWithFilesFragmentDoc = gql`
    fragment ClientWithFiles on Client {
  ...ClientDetails
  files {
    id
    fileName
    extension
    createdAt
    fileUrl
    quarantineStatus
    quarantineReason
    quarantineTimestamp
    scanEngine
    scanEngineVersion
    scanStartedAt
    scanCompletedAt
  }
}
    ${ClientDetailsFragmentDoc}`;
export const FileDetailsFragmentDoc = gql`
    fragment FileDetails on FileData {
  id
  fileName
  extension
  createdAt
  reviewedByCurrentUser
  quarantineStatus
  quarantineReason
  quarantineTimestamp
  scanEngine
  scanEngineVersion
  scanStartedAt
  scanCompletedAt
}
    `;
export const QuarantineFileDetailsFragmentDoc = gql`
    fragment QuarantineFileDetails on FileData {
  id
  fileName
  extension
  createdAt
  fileUrl
  folderPath
  subfolderPath
  clientId
  client {
    clientId
    client_name
    folder
  }
  user {
    id
    name
    role
  }
  quarantineStatus
  quarantineReason
  quarantineTimestamp
  scanEngine
  scanEngineVersion
  scanStartedAt
  scanCompletedAt
}
    `;
export const AllClientsDocument = gql`
    query AllClients {
  allClients {
    ...ClientDetails
  }
}
    ${ClientDetailsFragmentDoc}`;

/**
 * __useAllClientsQuery__
 *
 * To run a query within a React component, call `useAllClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllClientsQuery(baseOptions?: Apollo.QueryHookOptions<AllClientsQuery, AllClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllClientsQuery, AllClientsQueryVariables>(AllClientsDocument, options);
      }
export function useAllClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllClientsQuery, AllClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllClientsQuery, AllClientsQueryVariables>(AllClientsDocument, options);
        }
export function useAllClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllClientsQuery, AllClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllClientsQuery, AllClientsQueryVariables>(AllClientsDocument, options);
        }
export type AllClientsQueryHookResult = ReturnType<typeof useAllClientsQuery>;
export type AllClientsLazyQueryHookResult = ReturnType<typeof useAllClientsLazyQuery>;
export type AllClientsSuspenseQueryHookResult = ReturnType<typeof useAllClientsSuspenseQuery>;
export type AllClientsQueryResult = Apollo.QueryResult<AllClientsQuery, AllClientsQueryVariables>;
export const AdminClientsDocument = gql`
    query AdminClients {
  admin {
    clients {
      ...ClientWithFiles
    }
  }
}
    ${ClientWithFilesFragmentDoc}`;

/**
 * __useAdminClientsQuery__
 *
 * To run a query within a React component, call `useAdminClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminClientsQuery(baseOptions?: Apollo.QueryHookOptions<AdminClientsQuery, AdminClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminClientsQuery, AdminClientsQueryVariables>(AdminClientsDocument, options);
      }
export function useAdminClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminClientsQuery, AdminClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminClientsQuery, AdminClientsQueryVariables>(AdminClientsDocument, options);
        }
export function useAdminClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminClientsQuery, AdminClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminClientsQuery, AdminClientsQueryVariables>(AdminClientsDocument, options);
        }
export type AdminClientsQueryHookResult = ReturnType<typeof useAdminClientsQuery>;
export type AdminClientsLazyQueryHookResult = ReturnType<typeof useAdminClientsLazyQuery>;
export type AdminClientsSuspenseQueryHookResult = ReturnType<typeof useAdminClientsSuspenseQuery>;
export type AdminClientsQueryResult = Apollo.QueryResult<AdminClientsQuery, AdminClientsQueryVariables>;
export const AdminClientDocument = gql`
    query AdminClient($clientId: ID!) {
  admin {
    client(clientId: $clientId) {
      ...ClientWithFiles
    }
  }
}
    ${ClientWithFilesFragmentDoc}`;

/**
 * __useAdminClientQuery__
 *
 * To run a query within a React component, call `useAdminClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useAdminClientQuery(baseOptions: Apollo.QueryHookOptions<AdminClientQuery, AdminClientQueryVariables> & ({ variables: AdminClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminClientQuery, AdminClientQueryVariables>(AdminClientDocument, options);
      }
export function useAdminClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminClientQuery, AdminClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminClientQuery, AdminClientQueryVariables>(AdminClientDocument, options);
        }
export function useAdminClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminClientQuery, AdminClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminClientQuery, AdminClientQueryVariables>(AdminClientDocument, options);
        }
export type AdminClientQueryHookResult = ReturnType<typeof useAdminClientQuery>;
export type AdminClientLazyQueryHookResult = ReturnType<typeof useAdminClientLazyQuery>;
export type AdminClientSuspenseQueryHookResult = ReturnType<typeof useAdminClientSuspenseQuery>;
export type AdminClientQueryResult = Apollo.QueryResult<AdminClientQuery, AdminClientQueryVariables>;
export const AdminCreateClientDocument = gql`
    mutation AdminCreateClient($client_name: String!, $folder: String!) {
  admin {
    createClient(client_name: $client_name, folder: $folder) {
      ...ClientDetails
    }
  }
}
    ${ClientDetailsFragmentDoc}`;
export type AdminCreateClientMutationFn = Apollo.MutationFunction<AdminCreateClientMutation, AdminCreateClientMutationVariables>;

/**
 * __useAdminCreateClientMutation__
 *
 * To run a mutation, you first call `useAdminCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateClientMutation, { data, loading, error }] = useAdminCreateClientMutation({
 *   variables: {
 *      client_name: // value for 'client_name'
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useAdminCreateClientMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateClientMutation, AdminCreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateClientMutation, AdminCreateClientMutationVariables>(AdminCreateClientDocument, options);
      }
export type AdminCreateClientMutationHookResult = ReturnType<typeof useAdminCreateClientMutation>;
export type AdminCreateClientMutationResult = Apollo.MutationResult<AdminCreateClientMutation>;
export type AdminCreateClientMutationOptions = Apollo.BaseMutationOptions<AdminCreateClientMutation, AdminCreateClientMutationVariables>;
export const AdminUpdateClientDocument = gql`
    mutation AdminUpdateClient($clientId: ID!, $client_name: String, $folder: String, $upload_complete: Boolean) {
  admin {
    updateClient(
      clientId: $clientId
      client_name: $client_name
      folder: $folder
      upload_complete: $upload_complete
    ) {
      ...ClientDetails
    }
  }
}
    ${ClientDetailsFragmentDoc}`;
export type AdminUpdateClientMutationFn = Apollo.MutationFunction<AdminUpdateClientMutation, AdminUpdateClientMutationVariables>;

/**
 * __useAdminUpdateClientMutation__
 *
 * To run a mutation, you first call `useAdminUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateClientMutation, { data, loading, error }] = useAdminUpdateClientMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      client_name: // value for 'client_name'
 *      folder: // value for 'folder'
 *      upload_complete: // value for 'upload_complete'
 *   },
 * });
 */
export function useAdminUpdateClientMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateClientMutation, AdminUpdateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateClientMutation, AdminUpdateClientMutationVariables>(AdminUpdateClientDocument, options);
      }
export type AdminUpdateClientMutationHookResult = ReturnType<typeof useAdminUpdateClientMutation>;
export type AdminUpdateClientMutationResult = Apollo.MutationResult<AdminUpdateClientMutation>;
export type AdminUpdateClientMutationOptions = Apollo.BaseMutationOptions<AdminUpdateClientMutation, AdminUpdateClientMutationVariables>;
export const AdminDeleteClientDocument = gql`
    mutation AdminDeleteClient($clientId: ID!) {
  admin {
    deleteClient(clientId: $clientId)
  }
}
    `;
export type AdminDeleteClientMutationFn = Apollo.MutationFunction<AdminDeleteClientMutation, AdminDeleteClientMutationVariables>;

/**
 * __useAdminDeleteClientMutation__
 *
 * To run a mutation, you first call `useAdminDeleteClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteClientMutation, { data, loading, error }] = useAdminDeleteClientMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useAdminDeleteClientMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteClientMutation, AdminDeleteClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteClientMutation, AdminDeleteClientMutationVariables>(AdminDeleteClientDocument, options);
      }
export type AdminDeleteClientMutationHookResult = ReturnType<typeof useAdminDeleteClientMutation>;
export type AdminDeleteClientMutationResult = Apollo.MutationResult<AdminDeleteClientMutation>;
export type AdminDeleteClientMutationOptions = Apollo.BaseMutationOptions<AdminDeleteClientMutation, AdminDeleteClientMutationVariables>;
export const AllFilesDocument = gql`
    query AllFiles {
  allFiles {
    ...FileDetails
  }
}
    ${FileDetailsFragmentDoc}`;

/**
 * __useAllFilesQuery__
 *
 * To run a query within a React component, call `useAllFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllFilesQuery(baseOptions?: Apollo.QueryHookOptions<AllFilesQuery, AllFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllFilesQuery, AllFilesQueryVariables>(AllFilesDocument, options);
      }
export function useAllFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllFilesQuery, AllFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllFilesQuery, AllFilesQueryVariables>(AllFilesDocument, options);
        }
export function useAllFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllFilesQuery, AllFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllFilesQuery, AllFilesQueryVariables>(AllFilesDocument, options);
        }
export type AllFilesQueryHookResult = ReturnType<typeof useAllFilesQuery>;
export type AllFilesLazyQueryHookResult = ReturnType<typeof useAllFilesLazyQuery>;
export type AllFilesSuspenseQueryHookResult = ReturnType<typeof useAllFilesSuspenseQuery>;
export type AllFilesQueryResult = Apollo.QueryResult<AllFilesQuery, AllFilesQueryVariables>;
export const GetFileDocument = gql`
    query GetFile($id: ID!) {
  file(id: $id) {
    ...FileDetails
  }
}
    ${FileDetailsFragmentDoc}`;

/**
 * __useGetFileQuery__
 *
 * To run a query within a React component, call `useGetFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFileQuery(baseOptions: Apollo.QueryHookOptions<GetFileQuery, GetFileQueryVariables> & ({ variables: GetFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
      }
export function useGetFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileQuery, GetFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
        }
export function useGetFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFileQuery, GetFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
        }
export type GetFileQueryHookResult = ReturnType<typeof useGetFileQuery>;
export type GetFileLazyQueryHookResult = ReturnType<typeof useGetFileLazyQuery>;
export type GetFileSuspenseQueryHookResult = ReturnType<typeof useGetFileSuspenseQuery>;
export type GetFileQueryResult = Apollo.QueryResult<GetFileQuery, GetFileQueryVariables>;
export const CreateFileDocument = gql`
    mutation CreateFile($fileName: String!, $extension: String!, $clientId: ID!) {
  createFile(fileName: $fileName, extension: $extension, clientId: $clientId) {
    ...FileDetails
  }
}
    ${FileDetailsFragmentDoc}`;
export type CreateFileMutationFn = Apollo.MutationFunction<CreateFileMutation, CreateFileMutationVariables>;

/**
 * __useCreateFileMutation__
 *
 * To run a mutation, you first call `useCreateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileMutation, { data, loading, error }] = useCreateFileMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      extension: // value for 'extension'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useCreateFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateFileMutation, CreateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFileMutation, CreateFileMutationVariables>(CreateFileDocument, options);
      }
export type CreateFileMutationHookResult = ReturnType<typeof useCreateFileMutation>;
export type CreateFileMutationResult = Apollo.MutationResult<CreateFileMutation>;
export type CreateFileMutationOptions = Apollo.BaseMutationOptions<CreateFileMutation, CreateFileMutationVariables>;
export const UpdateFileDocument = gql`
    mutation UpdateFile($id: ID!, $fileName: String, $extension: String) {
  updateFile(id: $id, fileName: $fileName, extension: $extension) {
    ...FileDetails
  }
}
    ${FileDetailsFragmentDoc}`;
export type UpdateFileMutationFn = Apollo.MutationFunction<UpdateFileMutation, UpdateFileMutationVariables>;

/**
 * __useUpdateFileMutation__
 *
 * To run a mutation, you first call `useUpdateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileMutation, { data, loading, error }] = useUpdateFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fileName: // value for 'fileName'
 *      extension: // value for 'extension'
 *   },
 * });
 */
export function useUpdateFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileMutation, UpdateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileMutation, UpdateFileMutationVariables>(UpdateFileDocument, options);
      }
export type UpdateFileMutationHookResult = ReturnType<typeof useUpdateFileMutation>;
export type UpdateFileMutationResult = Apollo.MutationResult<UpdateFileMutation>;
export type UpdateFileMutationOptions = Apollo.BaseMutationOptions<UpdateFileMutation, UpdateFileMutationVariables>;
export const DeleteFileDocument = gql`
    mutation DeleteFile($id: ID!) {
  deleteFile(id: $id)
}
    `;
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const ToggleFileReviewDocument = gql`
    mutation ToggleFileReview($fileId: ID!) {
  toggleFileReview(fileId: $fileId) {
    id
    fileName
    extension
    createdAt
    reviewedByCurrentUser
    clientId
  }
}
    `;
export type ToggleFileReviewMutationFn = Apollo.MutationFunction<ToggleFileReviewMutation, ToggleFileReviewMutationVariables>;

/**
 * __useToggleFileReviewMutation__
 *
 * To run a mutation, you first call `useToggleFileReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFileReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFileReviewMutation, { data, loading, error }] = useToggleFileReviewMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useToggleFileReviewMutation(baseOptions?: Apollo.MutationHookOptions<ToggleFileReviewMutation, ToggleFileReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleFileReviewMutation, ToggleFileReviewMutationVariables>(ToggleFileReviewDocument, options);
      }
export type ToggleFileReviewMutationHookResult = ReturnType<typeof useToggleFileReviewMutation>;
export type ToggleFileReviewMutationResult = Apollo.MutationResult<ToggleFileReviewMutation>;
export type ToggleFileReviewMutationOptions = Apollo.BaseMutationOptions<ToggleFileReviewMutation, ToggleFileReviewMutationVariables>;
export const AdminQuarantinedFilesDocument = gql`
    query AdminQuarantinedFiles {
  admin {
    quarantinedFiles {
      ...QuarantineFileDetails
    }
  }
}
    ${QuarantineFileDetailsFragmentDoc}`;

/**
 * __useAdminQuarantinedFilesQuery__
 *
 * To run a query within a React component, call `useAdminQuarantinedFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuarantinedFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuarantinedFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminQuarantinedFilesQuery(baseOptions?: Apollo.QueryHookOptions<AdminQuarantinedFilesQuery, AdminQuarantinedFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuarantinedFilesQuery, AdminQuarantinedFilesQueryVariables>(AdminQuarantinedFilesDocument, options);
      }
export function useAdminQuarantinedFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuarantinedFilesQuery, AdminQuarantinedFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuarantinedFilesQuery, AdminQuarantinedFilesQueryVariables>(AdminQuarantinedFilesDocument, options);
        }
export function useAdminQuarantinedFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminQuarantinedFilesQuery, AdminQuarantinedFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminQuarantinedFilesQuery, AdminQuarantinedFilesQueryVariables>(AdminQuarantinedFilesDocument, options);
        }
export type AdminQuarantinedFilesQueryHookResult = ReturnType<typeof useAdminQuarantinedFilesQuery>;
export type AdminQuarantinedFilesLazyQueryHookResult = ReturnType<typeof useAdminQuarantinedFilesLazyQuery>;
export type AdminQuarantinedFilesSuspenseQueryHookResult = ReturnType<typeof useAdminQuarantinedFilesSuspenseQuery>;
export type AdminQuarantinedFilesQueryResult = Apollo.QueryResult<AdminQuarantinedFilesQuery, AdminQuarantinedFilesQueryVariables>;
export const AdminFilesByQuarantineStatusDocument = gql`
    query AdminFilesByQuarantineStatus($status: QuarantineStatus!) {
  admin {
    filesByQuarantineStatus(status: $status) {
      ...QuarantineFileDetails
    }
  }
}
    ${QuarantineFileDetailsFragmentDoc}`;

/**
 * __useAdminFilesByQuarantineStatusQuery__
 *
 * To run a query within a React component, call `useAdminFilesByQuarantineStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFilesByQuarantineStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFilesByQuarantineStatusQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAdminFilesByQuarantineStatusQuery(baseOptions: Apollo.QueryHookOptions<AdminFilesByQuarantineStatusQuery, AdminFilesByQuarantineStatusQueryVariables> & ({ variables: AdminFilesByQuarantineStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFilesByQuarantineStatusQuery, AdminFilesByQuarantineStatusQueryVariables>(AdminFilesByQuarantineStatusDocument, options);
      }
export function useAdminFilesByQuarantineStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFilesByQuarantineStatusQuery, AdminFilesByQuarantineStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFilesByQuarantineStatusQuery, AdminFilesByQuarantineStatusQueryVariables>(AdminFilesByQuarantineStatusDocument, options);
        }
export function useAdminFilesByQuarantineStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFilesByQuarantineStatusQuery, AdminFilesByQuarantineStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFilesByQuarantineStatusQuery, AdminFilesByQuarantineStatusQueryVariables>(AdminFilesByQuarantineStatusDocument, options);
        }
export type AdminFilesByQuarantineStatusQueryHookResult = ReturnType<typeof useAdminFilesByQuarantineStatusQuery>;
export type AdminFilesByQuarantineStatusLazyQueryHookResult = ReturnType<typeof useAdminFilesByQuarantineStatusLazyQuery>;
export type AdminFilesByQuarantineStatusSuspenseQueryHookResult = ReturnType<typeof useAdminFilesByQuarantineStatusSuspenseQuery>;
export type AdminFilesByQuarantineStatusQueryResult = Apollo.QueryResult<AdminFilesByQuarantineStatusQuery, AdminFilesByQuarantineStatusQueryVariables>;
export const GetUserDataDocument = gql`
    query GetUserData {
  currentUser {
    id
    name
    email
    role
    clientId
    client {
      clientId
      client_name
      folder
    }
    supplierId
    supplier {
      id
      name
      subfolder
      clientId
      client {
        clientId
        client_name
        folder
      }
    }
  }
}
    `;

/**
 * __useGetUserDataQuery__
 *
 * To run a query within a React component, call `useGetUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserDataQuery(baseOptions?: Apollo.QueryHookOptions<GetUserDataQuery, GetUserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDataQuery, GetUserDataQueryVariables>(GetUserDataDocument, options);
      }
export function useGetUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDataQuery, GetUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDataQuery, GetUserDataQueryVariables>(GetUserDataDocument, options);
        }
export function useGetUserDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserDataQuery, GetUserDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDataQuery, GetUserDataQueryVariables>(GetUserDataDocument, options);
        }
export type GetUserDataQueryHookResult = ReturnType<typeof useGetUserDataQuery>;
export type GetUserDataLazyQueryHookResult = ReturnType<typeof useGetUserDataLazyQuery>;
export type GetUserDataSuspenseQueryHookResult = ReturnType<typeof useGetUserDataSuspenseQuery>;
export type GetUserDataQueryResult = Apollo.QueryResult<GetUserDataQuery, GetUserDataQueryVariables>;